document.querySelectorAll('#product-page input[name="material-color"]:checked').forEach((element) => {
    let container = element.closest('.product-scope');
    let option = element.closest('.options');
    let productIndex = option.dataset.productIndex;
    let imageSlider = container.querySelector(`.image-slider .splide__list .splide__slide[data-type="preview"][data-product-index="${productIndex}"]`);
    let bgColor = document.querySelector('#bg-color-'+productIndex);

    if (bgColor) imageSlider.style.backgroundColor = bgColor.value;
});